var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-stats',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var query = ref.query;
return [_c('p',{staticClass:"hidden pb-4 text-3xl font-bold border-blue-100 text-grey-500 md:border-b md:block"},[(query)?_c('span',[_vm._v("For \""+_vm._s(query)+"\"")]):_c('span',[_vm._v(" ")])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }